// extracted by extract-css-chunks-webpack-plugin
module.exports = {"SectionText":"SectionText__SectionText__J7ZQz"};